module.exports = __webpack_public_path__ + "media/images/icons/xp-points_gravatar-202bc5bd3648e62dad9da958289e0521.png";